import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    height?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomElectionAdsOddsUp = ({ height = 120, props }: Props): JSX.Element => {
    const computedWidth = (height / 120) * 54;
    return (
        <SvgIcon {...props} style={{ width: computedWidth, height: height }} viewBox={`0 0 ${computedWidth} ${height}`}>
            <svg viewBox={`0 0 54 120`} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 32 32)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 43 43)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 32 43)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 21 43)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 54 54)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 43 54)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 32 54)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 21 54)'}
                    fill={'#21D99B'}
                />
                <circle
                    cx={'5'}
                    cy={'5'}
                    r={'5'}
                    transform={'matrix(-1 8.74228e-08 8.74228e-08 1 10 54)'}
                    fill={'#21D99B'}
                />
            </svg>
        </SvgIcon>
    );
};
